import React, { useEffect, useMemo, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"

import searchIcon from "../../../assets/images/icons/search-icon.svg"
import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import Sliders from "../../../assets/images/icons/sliders.svg"
import ArrowDown from "../../../assets/images/icons/arrow-down.svg"
import { useLazyGetWealtDashboardCompaniesAgreementsQuery } from "store/api/wealthpartnerapi/wealthReport"
import { formatAmount } from "helpers/common"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
  period: "This Year",
}
const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const CompanyAgreementsList = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [getResults, { isFetching }] =
    useLazyGetWealtDashboardCompaniesAgreementsQuery()
  const [data, setData] = useState([
    {
      id: 1,
      name: "Rohan Mehra",
      email: "rohan.mehra@prachay.in",
      count: 2,
      amount: "₹6,00,00,000",
      interest: "₹60,000",
      expanded: true,
      details: [
        {
          code: "PCL25ICD005",
          subData: [
            { amount: "₹3,00,00,000", interest: "₹30,000" },
            { amount: "₹2,00,00,000", interest: "₹20,000" },
          ],
        },
        {
          code: "PCL25ICD006",
          subData: [
            { amount: "₹3,00,000", interest: "₹30" },
            { amount: "₹2,00,00,000", interest: "₹1,000" },
          ],
        },
      ],
    },
  ])
  const [filters, setFilters] = useState(defaultFilters)

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const [openRows, setOpenRows] = useState({})

  const toggleRow = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }))
  }

  return (
    <React.Fragment>
      <div className="table-section-wrapper">
        <div className="table-top-section">
          <h6>Company Status</h6>
          <div className="tab-section wealth-patner-tab"></div>
          <div className="search-box-wrapp">
            <div className="search-box-section">
              <img src={searchIcon} alt="" />
            </div>
            <div className="dropdown-section">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret size="lg">
                  {filters.period} <img src={downArrowIcon} alt="" />
                </DropdownToggle>
                <DropdownMenu style={{ minWidth: "auto" }}>
                  {periods.map((item, index) => (
                    <DropdownItem
                      key={`periods_${index}`}
                      onClick={() => setFilters({ period: item })}
                    >
                      {item}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="filter-section">
              <img src={Sliders} alt="" />
            </div>
          </div>
        </div>

        <div className="table-container-wrapper-section">
          <div className="table-header">
            <div className="name">Name</div>
            <div className="master-agreement">
              Master Agreement
              {/* <img src={ArrowDown} alt="" /> */}
            </div>
            <div className="invested">
              Invested
              {/* <img src={ArrowDown} alt="" /> */}
            </div>
            <div className="commission-earned">
              Commission Earned
              {/* <img src={ArrowDown} alt="" /> */}
            </div>
          </div>
          {data.map((item) => (
            <div key={item.id} className="table-section">
              {/* Main Row */}
              <div
                className={`table-row ${openRows[item.id] ? "expanded" : ""}`}
              >
                <div className="left">
                  <div onClick={() => item.agreements && toggleRow(item.id)}>
                    <div
                      className={`toggle-icon ${openRows[item.id] ? "open" : "closed"}`}
                    >
                      {openRows[item.id] ? "-" : "+"}
                    </div>
                  </div>
                  <div className="info">
                    <div className="name">{item.name}</div>
                    <div className="email">{item.email}</div>
                  </div>
                </div>

                <div className="count">{item.count}</div>
                <div className="amount">₹ {formatAmount(item.invested)}</div>
                <div className="interest">
                  ₹ {formatAmount(item.commission)}
                </div>
              </div>

              {/* Expandable Section */}
              {item.agreements && openRows[item.id] && (
                <div className="expand-section">
                  {item.agreements.map((d, index) => (
                    <div key={index} className="expand-item">
                      <div className="expand-header">
                        <div className="code">{d.agreement_ref}</div>
                        <div
                          className="total"
                          onClick={() => toggleRow(`${item.id}-${index}`)}
                        >
                          ₹{" "}
                          {formatAmount(
                            parseFloat(Number(d.amount).toFixed(2))
                          )}
                          <i
                            className={`icon-keyboard_arrow_down ${
                              openRows[`${item.id}-${index}`] ? "rotate" : ""
                            }`}
                          ></i>
                        </div>
                      </div>

                      {openRows[`${item.id}-${index}`] &&
                        d.icd_requests.length > 0 && (
                          <div className="sub-data">
                            {d.icd_requests.map((s, i) => (
                              <div key={i} className="sub-row">
                                <div className="amount">
                                  ₹ {formatAmount(s.amount)}
                                </div>
                                <div className="interest">
                                  ₹ {formatAmount(s.commission)}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  )
}

export default CompanyAgreementsList
